// extracted by mini-css-extract-plugin
export default {"buttons":"Np32C"};